import { api } from './client'
import type { DashboardPayload } from '@/types/dashboard'

export function fetchDashboard(limit = 40, signal?: AbortSignal) {
  return api<DashboardPayload>(`/api/dashboard?limit=${limit}`, { signal })
}
